import { toastr } from "react-redux-toastr";
import {
  asyncActionError,
  asyncActionFinish,
  asyncActionStart,
} from "../../common/async/asyncActionStart";

export const uploadFile =
  (file, fileName, ticketId) =>
  async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();

    const path = `${ticketId}/documents`;
    const options = {
      name: fileName,
      contentType: file.type,
    };

    try {
      dispatch(asyncActionStart());
      console.log("file upload start");

      let uploadedFile = await firebase.uploadFile(path, file, null, options);

      //get url of the image

      let downloadURL =
        await uploadedFile.uploadTaskSnapshot.ref.getDownloadURL();

      let payload = {
        fileUrl: downloadURL,
        fileName: fileName,
        type: file.type,
      };

      // await firestore
      //   .update(
      //     {
      //       collection: 'complaints',
      //       doc: ticketId,
      //       subcollections: [{ collection: 'documents' }]
      //     },
      //     payload
      //   )
      //   .then(() => console.log('file was uploaded'))
      //   .catch(error => console.error(error));

      await firestore
        .collection("complaints")
        .doc(ticketId)
        .update({
          documents: firestore.FieldValue.arrayUnion(payload),
        })
        .then(() => console.log("file was uploaded"))
        .catch((error) => console.error(error));
      dispatch(asyncActionFinish());
      toastr.success("Success", `Your file ${fileName} was uploaded`);
    } catch (error) {
      dispatch(asyncActionError());
      console.error(error);
      toastr.error("Error", "Your file was not uploaded");
    }
  };

export const clearFiles =
  (complaintId) =>
  async (dispatch, getState, { getFirebase, getFirestore }) => {};

export const uploadAttachments =
  (file, fileName, complaintId, pathId, index, totalFilesLength, path) =>
  async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();

    const options = {
      name: fileName,
      contentType: file.type,
    };

    try {
      dispatch(asyncActionStart());

      let uploadedFile = await firebase.uploadFile(path, file, null, options);

      let downloadURL =
        await uploadedFile.uploadTaskSnapshot.ref.getDownloadURL();

      let payload = {
        fileUrl: downloadURL,
        fileName: fileName,
        type: file.type,
        filePath: `${path}/${fileName}`,
      };

      let ref = `emails/${complaintId}/${pathId}`;

      let update = {};
      update[`/files/${index}`] = payload;

      if (index === totalFilesLength - 1) {
        update[`/writeEnded/`] = true;
      }
      await firebase
        .ref(ref)
        .update(update)
        .then(() => {
          console.log("file uploaded");
        })
        .catch((error) => {
          console.error(error);
          toastr.error("Failed", "Email failed");
        });

      return payload;
    } catch (err) {
      console.error(err);
    }
  };
